import styled from 'styled-components';
import { Container } from '../../styles/Common';

const WhatWeAreSpecializeIn = () => {
  return (
    <>
      <Container>
        <Wrapper>
          <TopHeadingWrapper>
            <Heading>WHAT WE SPECIALIZE IN</Heading>
          </TopHeadingWrapper>
          <CardWrapper>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/envelop.png" alt="envelop" />
                <h2>Email Setup & Automations</h2>
              </div>
              <p className="text">
                We specialize in setting up custom and branded automated email
                sequences like abandon cart, post-purchase, new subscriber,
                browse abandonment, best seller "HYPE" flow etc.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/announce.png" alt="envelop" />
                <h2>SMS Marketing</h2>
              </div>
              <p className="text">
                Your customers want to hear from you and want to buy more
                products from your store! We help you send relevant and branded
                SMS to your customers to generate extra revenue
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/cloud.png" alt="envelop" />
                <h2>Brand Management</h2>
              </div>
              <p className="text">
                We manage your email list and segment people based on
                similarities so we can send out personalized content and
                optimize our email marketing efforts
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/envelop.png" alt="envelop" />
                <h2>Email Campaigns</h2>
              </div>
              <p className="text">
                We specialize in setting up custom and branded automated email
                sequences like abandon cart, post-purchase, new subscriber,
                browse abandonment, best seller "HYPE" flow etc.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/announce.png" alt="envelop" />
                <h2>Segmentations</h2>
              </div>
              <p className="text">
                Don't sell cat food to dog owners, it won't work. Every email
                sent by us is tailored for the right consumer. This reduces
                unsubscribe rates and increases conversions.
              </p>
            </SingleCard>
            <SingleCard>
              <div className="top">
                <img src="/assets/icons/cloud.png" alt="envelop" />
                <h2>Optimization</h2>
              </div>
              <p className="text">
                We perform A/B split tests on every email on a weekly bases so
                we can continue improving, scaling, and finding the perfect
                combinations your customers want to engage with.
              </p>
            </SingleCard>
          </CardWrapper>
        </Wrapper>
      </Container>
    </>
  );
};

export default WhatWeAreSpecializeIn;

const Wrapper = styled.div`
  padding: 55px 0;
  margin-bottom: 150px;

  @media (max-width: 576px) {
    margin-bottom: 40px;
    padding: 25px 0;
  }
`;

const TopHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 70px;

  @media (max-width: 576px) {
    margin-bottom: 40px;
  }
`;

const Heading = styled.h2`
  text-align: center;
  font-weight: 700;
  font-size: 55px;
  /* identical to box height */

  text-transform: uppercase;

  background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 576px) {
    font-size: 30px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;

  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const SingleCard = styled.div`
  width: 32%;
  background: #ffffff;
  box-shadow: 30px 40px 60px rgba(0, 0, 0, 0.06);
  border-radius: 15px;
  padding: 30px 30px 45px 30px;
  display: flex;
  flex-direction: column;
  transition: 0.3s;
  margin-bottom: 40px;

  .top {
    flex-direction: column;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
      width: 130px;
      height: auto;
      margin-bottom: 35px;
    }

    h2 {
      font-weight: 600;
      font-family: font-semibold;
      font-size: 25px;
      color: #000000;
      text-align: center;
      line-height: 1.4;
      transition: 0.3s;
    }
  }

  p.text {
    font-weight: 500;
    font-family: font-medium;
    font-size: 18px;
    text-align: center;
    color: rgb(152, 159, 179);
    line-height: 1.7;
    transition: 0.3s;
  }

  &:hover {
    background: #5da5ed;

    .top {
      h2 {
        color: #fff;
      }
    }

    p.text {
      color: #fff;
    }
  }

  @media (max-width: 576px) {
    width: 100%;
    background: #ffffff;
    box-shadow: 30px 40px 60px rgba(0, 0, 0, 0.06);
    border-radius: 15px;
    padding: 30px 30px 45px 30px;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    margin-bottom: 40px;

    .top {
      margin-bottom: 20px;

      img {
        width: 100px;
        height: auto;
        margin-bottom: 20px;
      }

      h2 {
        font-weight: 600;
        font-family: font-semibold;
        font-size: 22px;
        color: #000000;
        text-align: center;
        line-height: 1.4;
        transition: 0.3s;
      }
    }
  }
`;
